import type {
	SdkHandlersProvider,
	ServiceProvider } from '@wix/thunderbolt-symbols'
import { withDependencies } from '@wix/thunderbolt-ioc'
import type {
	INamedSignalsServiceConfig,
	INamedSignalsDefinition,
	INamedSignalsService } from '@wix/viewer-service-named-signals/definition'
import {
	NamedSignalsDefinition as definition
} from '@wix/viewer-service-named-signals/definition'
import { NamedSignalsService as impl } from '@wix/viewer-service-named-signals/implementations'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import type { SsrSignalsSdkHandlers } from './types'
import { NamedSignalsHandlersSymbol } from './symbols'

export const NamedSignalsServiceClient = withDependencies(
	[NamedSignalsHandlersSymbol],
	(namedSignalsHandlers): ServiceProvider<
		INamedSignalsDefinition,
		(opts: ServiceFactoryOpts<INamedSignalsServiceConfig>) => INamedSignalsService
	> => {
		const config: INamedSignalsServiceConfig = {
			onRemoteChange: async (cb) => {
				namedSignalsHandlers.onPlatformChange(cb)
			},
			updateRemote: async (name, value) => {
				namedSignalsHandlers.updatePlatform(name, value)
			},
		}

		return {
			definition,
			impl,
			config,
			hasNonSerializablePlatformConfig: true,
		}
	}
)

export const NamedSignalsServiceServer = withDependencies([], (): ServiceProvider<
	INamedSignalsDefinition,
	(opts: ServiceFactoryOpts<INamedSignalsServiceConfig>) => INamedSignalsService
> &
	SdkHandlersProvider<SsrSignalsSdkHandlers> => {
	const store: Record<string, any> = {}

	const config: INamedSignalsServiceConfig = {
		onRemoteChange: async () => {},
		updateRemote: async () => {},
	}

	return {
		definition,
		impl,
		config,
		hasNonSerializablePlatformConfig: true,
		platformConfig: { initialStore: store }, // will be used for service init in builder-component isolate

		getSdkHandlers: () => ({
			ssrSignals: {
				updateRemote: (name: string, value: any) => (store[name] = value),
			},
		}),
	}
})
